class PoPdpMatchWithSectionRender extends HTMLElement {
  static hasFetched = false; // Track if fetch has already occurred
  static clipOnContent = null; // Store fetched content for reuse

  constructor() {
    super();
  }

  connectedCallback() {
    this.sectionContainer = this.querySelector('.js-po-pdp-match-with-section-container');
    if (!this.sectionContainer) return;

    // Store containers even if fetch has already happened
    if (PoPdpMatchWithSectionRender.hasFetched) {
      this.sectionContainer.innerHTML = PoPdpMatchWithSectionRender.clipOnContent;
      return;
    }

    const productHandle = this.sectionContainer.dataset.productHandle;
    if (!productHandle) return;

    PoPdpMatchWithSectionRender.hasFetched = true;
    this.fetchAndRender(productHandle);
  }

  fetchAndRender(productHandle) {
    const url = window.Shopify.routes.root + `products/${productHandle}/?sections=po-pdp-match-with-rendered-content`;

    fetch(url)
      .then(res => res.json())
      .then(data => {
        PoPdpMatchWithSectionRender.clipOnContent = data['po-pdp-match-with-rendered-content'];
        this.injectContentIntoAllContainers();
        
      })
      .catch(err => {
        console.error("Failed to load dynamic section:", err);
        this.injectErrorIntoAllContainers();
      });
  }

  injectContentIntoAllContainers() {
    const template = document.createElement('template');
    template.innerHTML = PoPdpMatchWithSectionRender.clipOnContent.trim();

    document.querySelectorAll('po-pdp-match-with-section-render')
      .forEach((el, index) => {
        const container = el.querySelector('.js-po-pdp-match-with-section-container');
        if (!container) return;

        // Clone the content for this instance, so the original content can be modified safely for each loop
        // For each loop i use the original content so each instance gets the same base content
        const clonedContent = template.content.cloneNode(true);

        // Modify IDs to make them unique
        clonedContent.querySelectorAll('[id]').forEach(node => {
          const oldId = node.getAttribute('id');
          const newId = `${oldId}--instance-${index}`;
          node.setAttribute('id', newId);
        });

        // Inject the sanitized, cloned content into this container
        container.innerHTML = '';
        container.appendChild(clonedContent);
      });
  }


  injectErrorIntoAllContainers() {
    document.querySelectorAll('po-pdp-match-with-section-render')
      .forEach(el => {
        const container = el.querySelector('.js-po-pdp-match-with-section-container');
        if (container) {
          container.innerHTML = "<p>Could not load Clip-on products.</p>";
        }
      });
  }
}

if (!customElements.get("po-pdp-match-with-section-render")) {
  customElements.define("po-pdp-match-with-section-render", PoPdpMatchWithSectionRender);
}


class PoPdpMatchWith extends HTMLElement {
  constructor() {
    super();
    this.currentModelSize = this.dataset.currentModelSize;
    console.log("Current model size:", this.currentModelSize);
  }

  // CODE FROM OLIVER PEOPLE, CAN BE IMPROVED A LITTLE BIT FOR THE IMG UPDATE
  connectedCallback() {

    this.accessoryTitle = this.querySelector('.AccessoryTitle');
    this.accessoryImages = this.querySelectorAll('.accessoryImage img');

    this.accessoryItems = this.querySelectorAll('.frameGridItem');
    this.previousItem = this.accessoryItems[0];

    this.previewCliponCheckbox = this.querySelector('.previewClipon');

    // Text elements
    this.lensColorElement = this.querySelector('.LensColor');
    this.frameColorElement = this.querySelector('.FrameColor');
    this.ctaLinkElement = this.querySelector('.AccessoryCta');

    // Add to cart elements
    this.variantIdHiddenInput = this.querySelector('product-form form input[name="id"]');
    this.btnAddToCart = this.querySelector('.js-btn-add-match-with');

    // Select data-attributes from 'po-pdp-match-with-section-render'
    // Used to update modal part if the custom element is rendered inside a dialog tag
    this.updateModalHeader = this.closest('po-pdp-match-with-section-render').dataset.updateModalHeader;
    if (this.updateModalHeader == "true") {
      this.updateModalTitle(this.accessoryTitle.textContent)
    }

    this.accessoryItems.forEach((item) => {
      item.addEventListener('click', (evt) => {
        this.clipTriggerClick(item, evt);
        this.previousItem = item;
      });
      item.addEventListener('mouseenter', (evt) => this.clipTriggerClick(item, evt));
      item.addEventListener('mouseleave', (evt) => this.clipTriggerClick(this.previousItem, evt));
    });

    if (this.previewCliponCheckbox) {
      this.previewCliponCheckbox.addEventListener('click', () => {
        this.updateImageFromCheckbox(this.previewCliponCheckbox);
      });
    }
    
    subscribe(PUB_SUB_EVENTS.faceSizeSelection, (payload) => {
      
      if (this.currentModelSize) {
        this.setAttribute('data-current-model_size', payload.data.variant.model_size);
        this.currentModelSize = payload.data.variant.model_size;
      }
      
      setTimeout(() => {
        this.querySelector('.selected-accessory').click();
      }, 1000);
    });
  }

  clipTriggerClick(item, evt) {    
    if (evt.type === "click") this.accessoryItems.forEach((i) => i.classList.remove('selected-accessory'));
    if (evt.type === "click" || evt.type === "mouseleave") item.classList.add('selected-accessory');

    if (evt.type === "click") {
      const scriptTag = item.querySelector('script.js-item-data');
      if (!scriptTag) return;

      try {
        const variantData = JSON.parse(scriptTag.textContent);

        // Match using this.currentModelSize
        const matched = variantData.variants[this.currentModelSize];

        if (matched) {
          // Example: override matchedVariantId and stock (optional)
          const variantId = matched.id;
          const variantAvailable = matched.available;

          // You may also want to trigger UI update again:
          this.updateAddButton(variantId, variantAvailable);
        } else {
          this.btnAddToCart.disabled = true;
          console.warn('No variant found for model size:', this.currentModelSize);
        }
      } catch (err) {
        console.error('Failed to parse variant-data JSON', err);
      }
    }

    this.updateTitle(item);

    this.updateInfoAndCta(item);

    /** When checkbox is checked, show cliponPreview on hover; otherwise show normal image */
    const useCliponPreview = this.previewCliponCheckbox?.checked === true;
    const imageUrl = useCliponPreview && item.dataset.cliponPreview
      ? item.dataset.cliponPreview
      : item.dataset.image;
    this.updateImage(imageUrl);

    // Update Modal Parts if the conditions are met
    if (this.updateModalHeader == "true") {
      this.updateModalTitle(item.dataset.title)
    }
  }

  updateTitle(item) {
    if (item.dataset.title) {
      this.accessoryTitle.textContent = item.dataset.title;
    }
  }

  updateInfoAndCta(item) {
    const ctaUrl = item.dataset.ctaUrl;
    const isNewness = item.dataset.newness === 'true';

    this.lensColorElement.textContent = item.dataset.lensColor;
    this.frameColorElement.textContent = item.dataset.frameColor;
    
    this.ctaLinkElement.setAttribute('href', ctaUrl);

    this.querySelectorAll('.newnessBadge').forEach((badge) => {
      badge.classList.toggle('tw-hidden', !isNewness);
    });
  }

  updateImage(imageUrl) {
    this.accessoryImages.forEach(image => {
      image.src = imageUrl;
      image.srcset = '';
    });
  }

  updateImageFromCheckbox(checkbox) {
    const item = this.querySelector('.selected-accessory');
    const imageUrl = checkbox.checked ? item.dataset.cliponPreview : item.dataset.image;
    this.updateImage(imageUrl);
  }

  updateAddButton(variantId, variantAvailable) {
    if (variantId && variantAvailable) {
      if (this.variantIdHiddenInput) {
        this.variantIdHiddenInput.value = variantId;
      }
      if (variantAvailable === 'true' || variantAvailable === true) {
        this.btnAddToCart.disabled = false;
      } else {
        this.btnAddToCart.disabled = true;
      }
    }
  }

  // Update Modal Title if the custom element is rendered inside a dialog tag and conditions are met
  updateModalTitle(text) {
    this.modalTitleToUpdate = this.closest('dialog').querySelector('.tw-po-modal-header .js-modal-title-to-update');
    this.modalTitleToUpdate
      ? this.modalTitleToUpdate.textContent = text
      : null;

  }
}

if (!customElements.get("po-pdp-match-with")) {
  customElements.define("po-pdp-match-with", PoPdpMatchWith);
}